<template>
  <el-main>
    <el-card shadow="never">
      <div style="display:flex; flex-flow: row; margin: 30px 10px;">
        <div class="title">
          <h1>Olá, {{ nomeUsuario }}</h1>
          <h3>Bem-vindo ao gerenciador de conteúdo do Mosia Omnichannel</h3>
        </div>
        <div class="search-input">
          <el-input
            ref="inputSearch"
            v-model="searchText"
            :clearable=true
            :prefix-icon="!searchText ? 'el-icon-search' : ''"
            placeholder="Pesquisar Configuração"
            size="medium"
          />
        </div>
      </div>
      <navbar-card
        :menus="menuSearched"
      />
    </el-card>
  </el-main>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import NavbarCard from '@/components/shared/navbar/navbar-card-dashboards/navbar-card.vue'

export default {
  name: 'dashHome',
  components: {
    NavbarCard
  },
  data () {
    return {
      searchText: '',
      searchResult: null
    }
  },
  watch: {
    applicationMenu: {
      handler (menu) {
        if (((menu[0] || {}).childs || []).length === 1) {
          this.goTo(menu[0].childs[0].routerPath)
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapState('SelecionaAplicacao', ['aplicacoes']),
    ...mapGetters('SelecionaAplicacao', ['applicationMenu']),
    ...mapState('login', [
      'usuario',
      'operadora'
    ]),
    nomeUsuario () {
      return this.usuario.nome
    },
    menuSearched () {
      let menusFiltered = [...this.applicationMenu]
      if (this.searchText !== '') {
        const menuChilds = this.__concatChilds(menusFiltered)
        const filteredMenusChildren = menuChilds.filter(menu => menu.name.toLowerCase().includes(this.searchText.toLowerCase()))
        menusFiltered = (filteredMenusChildren.length > 0) ? this.__mounteMenu(filteredMenusChildren) : this.__mounteEmptyMenu()
      }

      return menusFiltered
    }
  },
  methods: {
    __mounteMenu (menu) {
      return [{
        childs: [...menu],
        icon: 'search',
        title: `${menu.length} ${menu.length > 1 ? 'resultados' : 'resultado'}`,
        routerName: null,
        showNavCardDash: true
      }]
    },
    __mounteEmptyMenu () {
      return [{
        childs: [],
        icon: 'search',
        title: 'Nenhum resultado encontrado',
        routerName: null,
        showNavCardDash: true
      }]
    },
    __getChilds (menu) {
      return menu.childs.map(child => {
        return {
          ...child,
          icon: menu.icon,
          parent: {
            title: menu.title,
            routerName: menu.routerName
          }
        }
      })
    },
    __concatChilds (menus) {
      return menus.reduce((acc, menu) => {
        return acc.concat(this.__getChilds(menu))
      }, [])
    },
    goTo (routerPath) {
      this.$router.push({
        path: routerPath
      })
    }
  },
  mounted () {
    document.addEventListener('keydown', event => {
      if (event.ctrlKey && event.shiftKey && event.key === 'F') {
        this.$refs.inputSearch.focus()
        event.preventDefault()
      }
      if (event.key === 'Escape') {
        this.$refs.inputSearch.blur()
        this.searchText = ''
        this.searchResult = null
      }
    })
  },
  beforeDestroy () {
    document.removeEventListener('keydown', event => {
      if (event.ctrlKey && event.shiftKey && event.key === 'F') {
        this.$refs.inputSearch.focus()
        event.preventDefault()
      }
      if (event.key === 'Escape') {
        this.$refs.inputSearch.blur()
        this.searchText = ''
        this.searchResult = null
      }
    })
  }
}
</script>
<style lang="less">
.search-input {
  width: 381px;
  text-align: center;

  .el-input {
    width: 381px;
    text-align: center;
    font: normal normal normal 18px/24px Open Sans;

    .el-input__inner {
      background: #E5F1FD 0 0 no-repeat padding-box;
      border-radius: 50px;
      color: #5D8CBA;
      border: none;
    }

    ::placeholder {
      text-align: center;
      color: #5D8CBA;
    }

    :active, :focus {
      border: 1px solid #5D8CBA;
    }

    .el-input__suffix {
      color: #5D8CBA;
      right: 15px;
    }

    :active, :focus {
      border: none;
    }
  }
}

</style>
<style lang="less" scoped>
.title {
  width: 100%;
}
.title h1 {
  font-family: "Open Sans", sans-serif;
  font-size: 26px;
  text-transform: capitalize;
}

.title h3 {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #555555;
}
</style>
